import { render, staticRenderFns } from "./landing-page-mobile-display.vue?vue&type=template&id=4ad838d6&scoped=true&lang=pug"
import script from "./landing-page-mobile-display.js?vue&type=script&lang=js&external"
export * from "./landing-page-mobile-display.js?vue&type=script&lang=js&external"
import style0 from "./landing-page-mobile-display.vue?vue&type=style&index=0&id=4ad838d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad838d6",
  null
  
)

export default component.exports